__turbopack_context__.v({
  "error": "Search-module__dLZJya__error",
  "search": "Search-module__dLZJya__search",
});
